import PATH from '../paths';

const name = 'IGROW Capital';
const key = 'igrowcapital';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.svg`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-igrow-red:                #B7364a;
    --color-igrow-blue:               #071E2B;
    --color-xusa-blueLight:           #818a91;

    --color-primary:                  var(--color-igrow-red);
    --color-secondary:                var(--color-igrow-blue);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-igrow-red);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-igrow-blue);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          90px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-igrow-blue);
    --sidebar-logo-bg-color: var(--color-igrow-red);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-xusa-blueLight);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-igrow-blue);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-igrow-red);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-igrow-red);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-igrow-red);
    --btn-primary--border:            var(--color-igrow-red);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-igrow-blue);
    --btn-primary--borderH:           var(--color-igrow-blue);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-igrow-red);
    --btn-secondary--color:           var(--color-igrow-blue);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-igrow-blue);
    --btn-secondary--colorH:          var(--color-igrow-blue);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
